import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "productManage",
  "use": "productManage-usage",
  "viewBox": "0 0 63.93 66.99",
  "content": "<symbol viewBox=\"0 0 63.93 66.99\" id=\"productManage\"><title>资源 105</title><g id=\"productManage_图层_2\" data-name=\"图层 2\"><g id=\"productManage_图层_1-2\" data-name=\"图层 1\"><path d=\"M52.38,23.1A11.55,11.55,0,1,0,40.83,11.55h0A10.54,10.54,0,0,0,41,13.48L24.93,19.84A13.48,13.48,0,1,0,13.49,40.42a13.68,13.68,0,0,0,7.89-2.54L37.33,53.82a9,9,0,0,0-1.12,4.31,8.86,8.86,0,1,0,4.35-7.62L24.62,34.57A13.24,13.24,0,0,0,27,26.94a13.73,13.73,0,0,0-.31-2.85l16-6.31a11.61,11.61,0,0,0,9.74,5.32Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/productManage.svg
// module id = z19k
// module chunks = 264